module.exports = "#footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  height: 40px;\n  background-color: #dbdbdb;\n  text-align: center;\n  text-decoration: underline;\n  font-size: 0.9em;\n}\n#footer a {\n  color: #727272;\n}\n#footer a:not(:first-of-type) {\n  margin-left: 0.5em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/public/public-footer.component.less
// module id = 572
// module chunks = 0